import { PayloadAction } from 'sos-common/js/commonTypes/action.types';
import { registersMap } from 'sos-common/js/commonTypes/FormBaseStore.types';

export const SET_REGISTERS = 'SET_REGISTERS';

export type setRegistersAction = PayloadAction<typeof SET_REGISTERS, registersMap>;

export function setRegisters(registers: registersMap) {
  return {
    type: SET_REGISTERS,
    payload: registers,
  } as setRegistersAction;
}
